import React, { FC } from 'react'
import { IStep1ModalText } from '../../interfaces/Step'

const Step1ModalText: FC<IStep1ModalText> = (props) => {
  const { totalDocuments, documentStatusTitle } = props
  return (
    <>
      <h2 className="mb35">VÉRIFIER LA QUALITÉ DE VOS PIÈCES</h2>
      <p className="mb15">Pièce(s) à vérifier : {totalDocuments}</p>
      <div className="backgroundWarningInfo py1 px1 mb15">
        <h4>{documentStatusTitle}</h4>
        <p>
          Merci de procéder à une vérification et décider de charger un nouveau
          document ou de poursuivre.
        </p>
      </div>
    </>
  )
}

export default Step1ModalText
